import { atom } from 'jotai';

import type { PendingJointInvitation } from '../types/PendingJointInvitations';

export const pendingJointInvitations = atom<PendingJointInvitation[]>([]);
